import { ColumnStore } from "@bryntum/schedulerpro";
import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { formatLocationLines } from "../../react/components/entityViews/location/utils/locationDisplay";
import { WIDGET_REGISTRY } from "../../other/constants/EntityManagerConfig.tsx";

import {
  defaultCellRenderer,
  geoLocationButtonUrlHelper,
  defaultGroupRenderer as groupRenderer,
  openGeneralWidgetFromGridRecord,
} from "../../other/utils/utils.jsx";
import { ICON_COL_DEF_WIDTH, SWIVU_TOOLTIP_TRIGGER_CLS } from "../../other/constants/OtherKeys.jsx";
import { LOCATION_GEO_BUTTON_CONFIG } from "../../other/constants/AddressGeoButtonConfig.jsx";

const getLocationIcon = (hasCordinates = false) => {
  const color = hasCordinates ? "text-primary" : "";
  return `<i class="fa-solid fa-location-dot text-[1.4em] ${color}"></i>`;
};

export class SwivuAddressColumn extends SwivuSortColumn {
  static get $name() {
    return "SwivuAddressColumn";
  }

  static get type() {
    return WIDGET_KEYS.swivuAddressColumn;
  }

  static get fields() {
    return [];
  }

  static get defaults() {
    return {
      flex: 1,
      groupRenderer,
      htmlEncode: false,
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      cellCls: "cursor-pointer",
      cls: "swivu-icon-column",
      field: "locationValue",
      editor: false,
    };
  }

  onLoad(project, otherParams) {
    this.project = project;
    this.editorHandler = otherParams?.editorHandler;
  }

  onSwivuColumnClick(e) {
    openGeneralWidgetFromGridRecord(this.editorHandler, e.record, WIDGET_REGISTRY.location.id);
  }

  renderer({ record }) {
    const location = record.location || null;
    const { subLine, heading, hasCoords } = formatLocationLines(location);
    const label = subLine || heading || "N/A";
    return `<div class="${SWIVU_TOOLTIP_TRIGGER_CLS} leading-[1.8em] w-full flex items-center gap-[0.8em]">
      ${getLocationIcon(hasCoords)}
      <span>${defaultCellRenderer({ value: label })}</span>
    </div>`;
  }

  headerRenderer({ column }) {
    return `<div class="flex gap-[0.8em] items-center [&_i]:leading-[2em]">
      ${getLocationIcon()}
      <span class="text-wrap">${column.text}</span>
    </div>`;
  }

  tooltipRenderer({ record, cellTooltip }) {
    const location = record.location || null;
    const { hasCoords, lat, lon } = formatLocationLines(location);

    cellTooltip.tip.minWidth = "auto";
    cellTooltip.tip.element.classList.add("swivu-contact-tooltip", "swivu-address-tooltip", "[&_.b-tooltip-content]:!p-0")

    /* if the lat & lon is not present in record then don't want to show tooltip, As the location is 'unresolved' */
    if (!hasCoords) {
      cellTooltip.hideDelay = 0;
      cellTooltip.tip.hide(); // Don't show tooltip
      return;
    }
    return {
      children: [
        {
          tag: "div",
          class: "swivu-contact-tooltip-content flex flex-col gap-2 p-1",
          children: [
            {
              tag: "div",
              class: "tooltip-contact-container flex flex-col gap-1",
              children: LOCATION_GEO_BUTTON_CONFIG.map(({ title, icon, url }, index) => {
                return {
                  tag: "a",
                  target: "_blank",
                  href: geoLocationButtonUrlHelper(url, { lat, lon }),
                  class: `swivu-address-link group flex items-center justify-between no-underline w-full px-3 py-2 rounded-md hover:bg-accent/80 transition-colors cursor-pointer text-foreground ${index < LOCATION_GEO_BUTTON_CONFIG.length - 1 ? 'border-b border-border' : ''}`,
                  html: `<span class="flex items-center gap-2.5">
                    <img src='${icon}' class="w-5 h-5 object-contain flex-shrink-0" alt="${title}" />
                    <span class="text-sm font-medium">${title}</span>
                  </span>
                  <i class="fa-solid fa-arrow-right-long text-muted-foreground opacity-0 group-hover:opacity-100 transition-all duration-200" style="transform: rotate(-45deg);"></i>`
                };
              })
            }
          ]
        }
      ]
    };
  }
}

ColumnStore.registerColumnType(SwivuAddressColumn);
